import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 18 18"
    {...props}
  >
    <defs>
      <linearGradient
        id="Qp5j7rxdrx-knzBV5iw5I__d"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#EFFFFF" />
        <stop offset="100%" stopColor="#FFF" />
      </linearGradient>
      <linearGradient
        id="Qp5j7rxdrx-knzBV5iw5I__e"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#EFFFFF" />
        <stop offset="100%" stopColor="#FFF" />
      </linearGradient>
      <radialGradient
        id="Qp5j7rxdrx-knzBV5iw5I__b"
        cx="11.317%"
        cy="2.521%"
        r="124.298%"
        fx="11.317%"
        fy="2.521%"
      >
        <stop offset="0%" stopColor="#74FFEF" />
        <stop offset="100%" stopColor="#56C7FC" />
      </radialGradient>
      <filter
        id="Qp5j7rxdrx-knzBV5iw5I__c"
        width="111.1%"
        height="111.1%"
        x="-5.6%"
        y="-5.6%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation={0.5}
        />
        <feOffset dy={1} in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.0530553431 0"
        />
      </filter>
      <rect
        id="Qp5j7rxdrx-knzBV5iw5I__a"
        width={18}
        height={18}
        x={0}
        y={0}
        rx={2}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <use
        xlinkHref="#Qp5j7rxdrx-knzBV5iw5I__a"
        fill="url(#Qp5j7rxdrx-knzBV5iw5I__b)"
      />
      <use
        xlinkHref="#Qp5j7rxdrx-knzBV5iw5I__a"
        fill="#000"
        filter="url(#Qp5j7rxdrx-knzBV5iw5I__c)"
      />
      <path
        fill="url(#Qp5j7rxdrx-knzBV5iw5I__d)"
        fillRule="nonzero"
        d="M14 13v.333a2 2 0 0 1-.4 1.2L12.5 16l-1.1-1.467a2 2 0 0 1-.4-1.2V13zM12.5 2A1.5 1.5 0 0 1 14 3.5V12h-3V3.5A1.5 1.5 0 0 1 12.5 2"
        transform="rotate(30 12.5 9)"
      />
      <path
        fill="url(#Qp5j7rxdrx-knzBV5iw5I__e)"
        fillRule="nonzero"
        d="M1.646 7.646c2.787-2.786 5.293-3.86 7.512-3.12 1.051.35 1.22 1.163.583 1.996-.256.335-.626.685-1.158 1.107l-.379.292-.429.317-.544.388-1.461 1.03-.372.273-.262.206-.202.17q-.255.216-.39.372l-.064.078.012.01c.105.078.24.157.417.247l.349.165.322.147c.796.367 1.153.635 1.213 1.176.069.616-.426 1.19-1.516 1.916a.5.5 0 1 1-.554-.832q.158-.106.29-.201l.241-.18.193-.16c.255-.223.36-.371.352-.432q0-.01-.024-.033l-.07-.055-.124-.077L5.5 12.4l-.21-.107-.497-.23c-.55-.251-.876-.44-1.146-.71-.51-.51-.23-1.038.505-1.693l.134-.117c.171-.146.296-.25.47-.382l.353-.26L6.96 7.593l.453-.328c.777-.575 1.267-1 1.535-1.35l.102-.136c.094-.133.098-.181-.008-.232l-.119-.046-.08-.027c-1.781-.593-3.941.332-6.488 2.88a.5.5 0 1 1-.708-.708"
      />
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
